import { memo as Memo, useMemo } from 'react';

const DefaultSelect = Memo((props) => {
	//! On Change
	const onChange = (e) => {
		props.onChange && props.onChange(props.list.filter((i) => i.value === e.target.value)[0]);
	};

	//! List Items
	const listItems = useMemo(() => {
		return (
			<select
				value={props.selected.value || props.placeholder || ''}
				onChange={(e) => onChange(e)}>
				{
					<option
						disabled
						value={props.placeholder}>
						{props.placeholder ? props.placeholder + (props.required ? '*' : '') : ''}
					</option>
				}
				{props.list.map((i, k) => (
					<option
						key={k}
						value={i.value}>
						{i.label}
					</option>
				))}
			</select>
		);
	}, [props.list, props.selected.value]);

	return (
		<div className={`select-cont default-select-cont ${props.className || ''} ${!props.selected.value ? 'placeholder' : ''} ${props.errorMsg ? 'error' : ''} ${props.leftIcon ? 'with-left-icon' : ''}`}>
			{props.leftIcon && (typeof props.leftIcon === 'string' ? <i className={`select-left-icon ${props.leftIcon}`} /> : <i className={`select-left-icon`}>{props.leftIcon}</i>)}

			{listItems}

			<i className={`select-icon ${props.icon || 'ma-arrow-down'}`} />
		</div>
	);
});

export default DefaultSelect;
